import { render, staticRenderFns } from "./wjCurrency.vue?vue&type=template&id=20e5ac93&scoped=true"
import script from "./wjCurrency.vue?vue&type=script&lang=js"
export * from "./wjCurrency.vue?vue&type=script&lang=js"
import style0 from "./wjCurrency.vue?vue&type=style&index=0&id=20e5ac93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5ac93",
  null
  
)

export default component.exports